import { Box, Container, Paper, Typography } from '@mui/material';
import { SignUp } from '@clerk/clerk-react';

const SignUpPage = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: '70vh', md: '75vh' },
        py: { xs: 8, md: 12 },
      }}
    >
      <Paper
        elevation={4}
        sx={{
          width: '100%',
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
          textAlign: 'center',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Create your account
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Sign up to start using GroupMyChannels.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <SignUp
            routing="path"
            path="/sign-up"
            signInUrl="/login"
            fallbackRedirectUrl="/api/auth/signin"
            oauthFlow="redirect"
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default SignUpPage;
